import { Box, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

import { useApiServiceContext } from "@bujus/common-frontend";

import {
    HorizontalCenterCircularProgress,
    HorizontalCenterErrorMessage,
    LoginButton,
} from "@/base";
import {
    useAccountDashboardMailAddressStateContext,
    useAccountDashboardTitleStateContext,
} from "@/contexts";

import { AccountMailAddressVerificationPage__Logic } from "./account-mail-address-verification-page__logic";

const AccountMailAddressVerificationPage = () => {
    const params = useParams();

    const apiService = useApiServiceContext();
    const [, setAccountDashboardTitle] = useAccountDashboardTitleStateContext();
    const [, setAccountDashboardMailAddress] = useAccountDashboardMailAddressStateContext();

    const query = useQuery(
        ["_schools", "validateMailAddressVerificationToken", params.token],
        async ({ queryKey: key }) =>
            apiService.schools.validateMailAddressVerificationTokenAsync(key[2]),
        {
            onSuccess: (data) => {
                setAccountDashboardMailAddress(data.verifiableMailAddress);
            },
        },
    );

    useEffect(() => {
        setAccountDashboardTitle("Email-Adresse bestätigen");
    }, []);

    if (query.isLoading) {
        return <HorizontalCenterCircularProgress />;
    }
    if (query.isError) {
        return (
            <>
                <HorizontalCenterErrorMessage error={query.error} />
                <Box display="flex" justifyContent="center" mt={2}>
                    <LoginButton />
                </Box>
            </>
        );
    }
    if (query.isSuccess) {
        return (
            <>
                <Typography align="center" color="textSecondary">
                    Für {query.data.name}
                </Typography>
                <Box mt={2}>
                    <AccountMailAddressVerificationPage__Logic token={params.token} />
                </Box>
            </>
        );
    }
    return undefined;
};

export { AccountMailAddressVerificationPage };
